import isNil from 'lodash/isNil';
import includes from 'lodash/includes';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import { NotInsuredReason } from '../../types/not_insured_reason.enum';
import type { Step } from '../types/step';
import { AutoInsuredLength } from '../../types/auto_insured_length.enum';

export const InsuredHistoryOnboardingStep: Step = {
  // Ask insured history
  id: 'askInsuredHistory',
  pathname: '/insuredhistory',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }

    // Partner prefilled, don't show
    if (
      appData.signupParams?.partnerSignup &&
      !!appData.partnerSkippableData?.autoInsuredLength &&
      !includes(
        [AutoInsuredLength.LessThanSixMonths, AutoInsuredLength.SixToTwelveMonths],
        appData.partnerSkippableData?.autoInsuredLength
      )
    ) {
      return false;
    }

    return (
      !appData.isOnboardingLite &&
      !appData.featureData?.askICVBeforeOnboarding &&
      /**
       * Show when:
       * 1. user select not insured then then select reason: expired 30 day
       * 2. user select have insured
       */
      (appData.signupParams?.notInsuredReason === NotInsuredReason.EXPIRED_LAST_30_DAYS ||
        !!appData.signupParams?.isAutoInsured)
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.signupParams?.autoInsuredLength),
  category: () => StepCategory.Insurance,
};
